// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-a0cd3a92] .vue-treeselect__control {\n  background: #5b6064;\n  border-color: #000;\n}\n[data-v-a0cd3a92] .vue-treeselect__control .vue-treeselect__single-value {\n    color: #fff;\n}\n", ""]);
// Exports
module.exports = exports;
